import * as React from 'react';
import {
  Accordion,
  AccordionGroup,
  Heading,
  List,
  ListItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Text,
} from '@origin-digital/ods-core';

export const BattLiteEligibilityCriteriaModal = (
  <Stack data-id="plan-key-details-info-modal">
    <Heading variant="h3">Confirm your eligibility</Heading>
    <Stack space="xxsmall">
      <Text weight="medium">To be eligible for this Energy Plan:</Text>
      <List space="xxsmall">
        <ListItem>
          <Text variant="body-small">your solar PV system must be net metered</Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            your solar PV system must not exceed 50KW of inverter capacity or must be limited to
            50KW of export
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            you must not be receiving a feed-in tariff under any government scheme.
          </Text>
        </ListItem>
      </List>
    </Stack>
    <Stack>
      <AccordionGroup
        id="plan-accordion-group"
        data-id="plan-accordion-group"
        space="medium"
        variant="outlined"
      >
        <Accordion summary="Alpha ESS" id="AlphaModel" data-id="AlphaModel">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Inverter models</TableCell>
                <TableCell>Battery models</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>SMILE-G2-S5</TableCell>
                <TableCell>M4856-P</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE-G3-B5-INV</TableCell>
                <TableCell>M4856-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE-G3-S5-INV</TableCell>
                <TableCell>SMILE-B3-PLUS</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE-M5</TableCell>
                <TableCell>SMILE-BAT-10.1P</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE-S5-HV-INV</TableCell>
                <TableCell>SMILE-BAT-10.3P</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE-S6-HV-INV</TableCell>
                <TableCell>SMILE-BAT-13.3P</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE-T10-HV-INV</TableCell>
                <TableCell>SMILE-BAT-5PH</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>SMILE5-INV</TableCell>
                <TableCell>SMILE-BAT-8.2PH</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Storion-SMILE-B3</TableCell>
                <TableCell>SMILE-G2-B5</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>SMILE-G3-BAT-10.1P</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>SMILE-G3-BAT-4.0S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>SMILE-M5</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>SMILE-S6-HV</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>SMILE5-BAT</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Storion T10</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Storion T100</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Storion T30</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Storion-SMILE-B3</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Accordion>
        <Accordion summary="Ambrion" id="AmbrionModel" data-id="AmbrionModel">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Inverter models</TableCell>
                <TableCell>Battery models</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>HS2 - 10K - T2-X</TableCell>
                <TableCell>HS2 - 10K - T2-X</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>HS2 - 3K - S2</TableCell>
                <TableCell>HS2 - 3K - S2</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>HS2 - 5K - S2</TableCell>
                <TableCell>HS2 - 5K - S2</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>HS2 - 6K - S2</TableCell>
                <TableCell>HS2 - 6K - S2</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Accordion>
        <Accordion summary="AnkerSolix" id="AnkerSolixModel" data-id="AnkerSolixModel">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Inverter models</TableCell>
                <TableCell>Battery models</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>X1-H10K-T</TableCell>
                <TableCell>X-P6K-B25-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-H12K-T</TableCell>
                <TableCell>X1-B10-HC</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-H5K-S</TableCell>
                <TableCell>X1-B15-HC</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-H5K-T</TableCell>
                <TableCell>X1-B20-HC</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-H6K-S</TableCell>
                <TableCell>X1-B25-HC</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-H8K-T</TableCell>
                <TableCell>X1-B30-HC</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-P5K-S</TableCell>
                <TableCell>X1-B5-H</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>X1-P6K-S</TableCell>
                <TableCell>X1-P6K-B05-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>X1-P6K-B10-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>X1-P6K-B15-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>X1-P6K-B20-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>X1-P6K-B25-S</TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>X1-P6K-B30-S</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Accordion>
      </AccordionGroup>
    </Stack>
  </Stack>
);
